import IAmGodLanding from "./pages/IAmGodLanding";

function App() {
  return <IAmGodLanding />;
}

export default App;